import { atom, useAtom } from 'jotai'
import _ from "lodash"
import { useState, useEffect, forwardRef } from 'react'
import { propTypes } from 'react-bootstrap/esm/Image'
import Spinner from '../components/Spinner'
import { isAnimationsPausedAtom} from '../atoms/atom.config.js'

// video preloading: https://web.dev/fast-playback-with-preload/

const VideoBackground = ({url,poster}) => {
  const videoBgStyles = {
    //...constants.mainViewportHeightStyle,
    'zIndex': 0,
  }
  return <div
    tabIndex="-1"
    style={videoBgStyles}
    className='absolute h-displayHt w-screen animate-fadein'
  >
    <video tabIndex="-1" autoPlay playsInline disablePictureInPicture loop muted id='video' controls={false} className='h-full w-full object-cover' poster={poster}>
      <source src={url} type='video/mp4'/>
    </video>
  </div>
}

// now shows a spinner when loading, then fades video in
const VideoBackgroundFixed = ({url,poster,spinner,preloadCB,overlay}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAnimationPaused, setAnimationPaused] = useAtom(isAnimationsPausedAtom);

  const videoBgStyles = {
    //...constants.mainViewportHeightStyle,
    'zIndex': 0,
  }
  const cnFade = `${(isLoading) ? '' : 'animate-fadein'}`;
  return (  
    <div
      tabIndex="-1"
      style={videoBgStyles}
      className='fixed h-displayHt w-screen'
    >
      {isLoading && <Spinner icon={spinner}/>}
      {!isAnimationPaused &&
      <video tabIndex="-1" autoPlay playsInline disablePictureInPicture loop muted preload={'auto'} controls={false} id='video' className={'h-full w-full object-cover '+cnFade} poster={poster} onLoadedData={(e) => {
        //setTimeout(() => {
          console.log("videoloadeddata event", e)
          //document.getElementById('video-player').controls = false
          setIsLoading(false)
          if(preloadCB) {
            preloadCB(url)
            //onClick={props.onClick}
          }
        //},2000);
      }} onError={(e) => {
        console.log("MediaBackground ERROR event", e)
        setIsLoading(false)
          if(preloadCB) {
            preloadCB(url)
            //onClick={props.onClick}
          }
      }}>
        <source src={url} type='video/mp4'/>
      </video>   
      } 
      {isAnimationPaused &&
      <div className={'absolute h-full w-screen top-0 left-0 '+cnFade} >
        <img src={poster} className='h-full w-full object-cover relative' onLoad={() => {
          setIsLoading(false)
          if(preloadCB) {
            preloadCB(url)
            //onClick={props.onClick}
          }
        }} />
      </div>}
      {overlay && 
      <div className={'absolute h-full w-screen top-0 left-0 '+cnFade} >
        <img src={overlay} className='h-full w-full object-cover relative'/>
      </div>
    }
    </div> )
}

const ImageBackgroundFixed = ({url,poster}) => {
  const [isLoading, setIsLoading] = useState(true);

  const videoBgStyles = {
    //...constants.mainViewportHeightStyle,
    'zIndex': 0,
  }
  const cnFade = `${(isLoading) ? '' : 'animate-fadein'}`;
  return (  
    <div
      style={videoBgStyles}
      className='fixed h-displayHt w-screen'
    >
      {isLoading && <Spinner />}
      <div className={'absolute h-full w-screen '+cnFade} >
        <img src={url} className='h-full w-full object-cover relative' alt="" onLoad={() => {
          //setTimeout(() => {
            console.log("ImageBackgroundFixed imageloaded event")
            setIsLoading(false)
          //},2000);
        }}/>
      </div>
    </div> )
}

// could be image or video
// npreloader=true means hide the spinner when loading eg. the first slide of notes.js already has a preloader for the wavy note
// - withthe placeholder image it now looks like it jumps when the video finishes loading
const MediaBackground = ({url,poster,spinner,npreloader,preloadCB,overlay}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAnimationPaused, setAnimationPaused] = useAtom(isAnimationsPausedAtom);

  const isVideo = (url) => {
    let extension = url.split('.').pop();
    //console.log("MediaBackground", extension)
    //return extension.toLowerCase() == "mp4";
    return extension.toLowerCase() == "mp4" || extension.toLowerCase() == "m4v";
  };

  // if we just wait until the dom is rendered (eg. placeholder) then we could fade the item in now instead of waiting for the video loaded event?
  // useEffect(() => {
  //   console.log("MediaBackground dom rendered")
  //   setIsLoading(false)
  // }, []);

  // https://stackoverflow.com/questions/3846868/why-wont-tabindex-work-with-firefox

  const videoBgStyles = {
    //...constants.mainViewportHeightStyle,
    'zIndex': 0,
  }
  const cnFade = `${(isLoading) ? '' : 'animate-fadein'}`;
  return <div
    tabIndex="-1"    
    style={videoBgStyles}
    className='absolute h-full w-screen'
  >
    {(isLoading && !npreloader) && <Spinner icon={spinner}/>}
    { !isAnimationPaused && isVideo(url) ?
    <video tabIndex="-1" autoPlay playsInline disablePictureInPicture loop muted id='video' controls={false} className={'h-full w-full object-cover relative '+cnFade} poster={poster} onLoadedData={(e) => {
      // changing from onLoadedData to onCanPlayThrough: https://www.w3schools.com/tags/av_event_canplaythrough.asp
      // setTimeout(() => {
        console.log("MediaBackground videoloadeddata event", e)
        //e.target.play() // doesnt work :(
        setIsLoading(false)
        if(preloadCB) {
          preloadCB(url)
          //onClick={props.onClick}
        }
      // },10000);
    }} onError={(e) => {
      console.log("MediaBackground ERROR event", e)
      setIsLoading(false)
        if(preloadCB) {
          preloadCB(url)
          //onClick={props.onClick}
        }
    }}>
      <source src={url} type='video/mp4'/>
    </video>
    : <div className={'absolute h-full w-screen '+cnFade} >
        <img src={url} className='h-full w-full object-cover relative' alt="" onLoad={() => {
          //setTimeout(() => {
            console.log("MediaBackground imageloaded event")
            setIsLoading(false)
          //},2000);
        }}/>
      </div>
    }
    {(isAnimationPaused && isVideo(url)) &&
      <div className={'absolute h-full w-screen top-0 left-0 '+cnFade} >
        <img src={poster} className='h-full w-full object-cover relative' onLoad={() => {
          setIsLoading(false)
          if(preloadCB) {
            preloadCB(url)
            //onClick={props.onClick}
          }
        }} />
      </div>}
    {overlay && 
      <div className={'absolute h-full w-screen top-0 left-0'+cnFade} >
        <img src={overlay} className='h-full w-full object-cover relative'/>
      </div>
    }
  </div>
}

export default VideoBackground
export {
  VideoBackground,
  VideoBackgroundFixed,
  ImageBackgroundFixed,
  MediaBackground
}